import { render } from "./InstanceChargesTable.vue?vue&type=template&id=71ae7334"
import script from "./InstanceChargesTable.vue?vue&type=script&lang=js"
export * from "./InstanceChargesTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__